import { Body, breakpoints, Input, Spacer } from '@spritz-finance/ui'
import { useState } from 'react'
import { EmojiLogo } from '../../../../components/EmojiLogo'
import { Column } from '../../../../components/Layout/Column'
import { useDebounce } from '../../../../utils/useDebounce'
import plus from '../../../../assets/icons/plus-emoji.png'
import { BackButton } from './BackButton'
import { useLinkBillContext } from './LinkBill'
import { MerchantSelect } from './MerchantSelect'
import { LinkBill } from './types'
import { BillIcon } from '../bills/BillIcon'
import styled from 'styled-components'

const Container = styled(Column)`
    position: relative;
    min-width: 670px;
    ${breakpoints.small} {
        min-width: 632px;
    }
    @media (max-width: 657px) {
        min-width: unset;
    }
`
export const AddNewBill = () => {
    const { setStep, selectBillType } = useLinkBillContext()
    const [search, setSearch] = useState('')
    const searchTerm = useDebounce(search)

    const line = selectBillType ? selectBillType.merchantSearch : 'Add another bill'
    const onBack = () => setStep(LinkBill.SelectBillType)

    return (
        <Container align="center">
            <BackButton onClick={onBack} />
            {selectBillType ? (
                selectBillType.icon ? (
                    selectBillType.icon
                ) : (
                    <BillIcon type={selectBillType.type} />
                )
            ) : (
                <EmojiLogo src={plus} />
            )}
            <Spacer height={16} />
            <Body.SmBold>{line}</Body.SmBold>
            <Spacer height={32} />
            <div style={{ width: '100%' }}>
                <Input
                    search
                    placeholder="Search for your bill pay provider"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>
            <MerchantSelect searchTerm={searchTerm} onBack={onBack} />
        </Container>
    )
}
